import { render, staticRenderFns } from "./YoukeQingxuFenxiDetail.vue?vue&type=template&id=2767ca12&scoped=true&"
import script from "./YoukeQingxuFenxiDetail.vue?vue&type=script&lang=js&"
export * from "./YoukeQingxuFenxiDetail.vue?vue&type=script&lang=js&"
import style0 from "./YoukeQingxuFenxiDetail.vue?vue&type=style&index=0&id=2767ca12&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2767ca12",
  null
  
)

export default component.exports